<template>
    <div class="Item">
        <headerItem msg="年贷款情况概览" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
        <div class="grid-container">
            <div class="grid-item d-flex fl-dir-column item-center ju-center"
            v-for="item in list" :key="item.name">
                <div class="f-22 default-color">{{ item.name }}</div>
                <div class="f-30 hign-white">{{ item.value }} <span class="f-20 default-color"> {{ item.unit }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import headerItem from '../components/headerItem.vue';
export default {
    name: '',
    components: {
        headerItem
    },
    props: {
        current: Number,
    },
    watch: {
        current(newVal, oldVal) {
            if (newVal === 1) {
                this.list = this.list1
            } else if (newVal === 0) {
                this.list = this.list0
            }
        }
    },
    data() {
        return {
            rightSelect: {
                type: 'radio',
                list: [
                    { label: '累计', value: '0' },
                    { label: '当日', value: '1' }
                ],
                value: '0'
            },
            list: [],
            list0: [
                { name: '授信金额', value: '127068', unit: '万元' },
                { name: '贷款余额', value: '37862', unit: '万元' },
                { name: '申请客户', value: '2077', unit: '人' },
                { name: '授信客户', value: '1973', unit: '人' },
            ],
            list1: [
                { name: '授信金额', value: '220900', unit: '万元' },
                { name: '贷款余额', value: '37000', unit: '万元' },
                { name: '申请客户', value: '2277', unit: '万人' },
                { name: '授信客户', value: '2033', unit: '万人' },
            ]
        }
    },
    mounted() {
        this.list = this.list0
    }
}
</script>

<style lang="less" scoped>
.Item{
    .grid-container {
        width: 90%;
        margin: 10px auto 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 10px;
        justify-items: center;
        .grid-item {
            box-sizing: border-box;
            height: 120px;
            width: 220px;
            border: 2px solid rgb(143, 167, 215);
            text-align: center;
            padding: 14px;
            border-radius: 2px;
        }
    }
}
</style>
